import "../assets/styles/pages/contact.css";
import ContactForm from "../components/ContactForm";

function Contact() {
    return (
        <section id="contact" className="contact section bg-raised" aria-labelledby="contact-title">
            <div className="shell contact__shell">
                <header className="section__header contact__intro">
                    <p className="section__eyebrow">Let&apos;s talk</p>
                    <h2 id="contact-title" className="section__title">
                        Contact
                    </h2>
                    <p className="section__lead">
                        Open to interesting projects and collaborations. Prefer email or the form — I reply as soon as I
                        can.
                    </p>
                </header>

                <div className="contact__grid">
                    <aside className="contact__aside" aria-label="Contact details">
                        <div className="contact-block">
                            <h3 className="contact-block__label">Email</h3>
                            <a className="contact-block__value" href="mailto:korolov.anton01@gmail.com">
                                korolov.anton01@gmail.com
                            </a>
                        </div>
                        <div className="contact-block">
                            <h3 className="contact-block__label">LinkedIn</h3>
                            <a
                                className="contact-block__value"
                                href="https://www.linkedin.com/in/antoosha/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                linkedin.com/in/antoosha
                            </a>
                        </div>
                        <div className="contact-block">
                            <h3 className="contact-block__label">Location</h3>
                            <p className="contact-block__value contact-block__value--plain">Prague, Czech Republic</p>
                        </div>
                    </aside>

                    <ContactForm />
                </div>
            </div>
        </section>
    );
}

export default Contact;
